import React from 'react';
// @ts-ignore
import { LogClick } from 'features/shared/ClickStream';
import SideBarTemplate, { Link, Nav } from 'features/shared/layouts/shared/SideBarTemplate';
import Spacer from 'features/shared/Spacer';

const scrollToTop = () => window.scroll(0, 0);

const Sidebar = () => {
  return (
    <SideBarTemplate>
      <Nav>
        <LogClick eventType="open_schools_page" eventInfo="Переход на страницу школ">
          <Link to="/schools" onClick={scrollToTop}>
            Школы
          </Link>
        </LogClick>
        <LogClick eventType="open_olympiads_page" eventInfo="Переход на страницу олимпиад">
          <Link to="/olympiads" onClick={scrollToTop}>
            Олимпиады
          </Link>
        </LogClick>
        <LogClick eventType="open_knowledge_slices_page" eventInfo="Переход на страницу срезов знаний">
          <Link to="/knowledge_slices" onClick={scrollToTop}>
            Срезы знаний
          </Link>
        </LogClick>
        {/* <LogClick eventType="open_courses_page" eventInfo="Переход на страницу КПК">
          <Link to="/courses" onClick={scrollToTop}>
            КПК
          </Link>
        </LogClick> */}
        <LogClick eventType="open_webinars_page" eventInfo="Переход на страницу Обучение учителей">
          <Link to="/webinars" onClick={scrollToTop}>
          Обучение учителей
          </Link>
        </LogClick>
        {/* <LogClick eventType="open_teacher_review_page" eventInfo="Переход на страницу Отзывы учителей">
          <Link to="/reviews" onClick={scrollToTop}>
            Отзывы учителей
          </Link>
        </LogClick> */}
      </Nav>
      <Spacer />

      {/* <Nav>
        <LogClick eventType="open_expert_opinion_page" eventInfo="Переход на страницу Заключения экспертов">
          <Link to="/expert_opinion" onClick={scrollToTop} style={{ textTransform: 'none' }}>
            Заключения экспертов
          </Link>
        </LogClick>
      </Nav> */}
    </SideBarTemplate>
  );
};

export default Sidebar;
